export default {
  /* Maps.svelte */
  mapsDataLayerStyles: undefined,
  /* Plans.svelte */
  delayedPlansStyles: {
    start: undefined,
    end: undefined,
  },
};
